import axios from 'axios';

const updateWarehouses = function () {
  axios
    .get('/warehouses_by_plant', {
      params: { plant_id: $('.adjustment_plant_select').val() },
    })
    .then(response => {
      const select = $('.adjustment_warehouses_select');
      select.empty();
      $.each(response.data, function (_, warehouse) {
        select.append(
          $('<option>', {
            text: warehouse.code_and_name,
            value: warehouse.id,
          })
        );
      });
      select.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  $('.adjustment_plant_select').on('change', updateWarehouses);
  $('.adjustment_plant_select').select2({
    placeholder: 'Seleccione una planta...',
  });
  $('.adjustment_warehouses_select').select2({
    placeholder: 'Seleccione uno o varios almacenes de la planta...',
  });
  $('[name="stock_adjustment[adjustment_type]"]').on('click', function () {
    if (
      $('#stock_adjustment_adjustment_type_selected_products').is(':checked')
    ) {
      $('#stock-adjustment-products-table').removeClass('d-none');
      this.prop('checked', true);
    }
    if ($('#stock_adjustment_adjustment_type_all_products').is(':checked')) {
      $('#stock-adjustment-products-table').addClass('d-none');
      this.prop('checked', true);
    }
  });
  if ($('#stock_adjustment_adjustment_type_selected_products').is(':checked')) {
    $('#stock-adjustment-products-table').removeClass('d-none');
    this.prop('checked', true);
  }
  $('#adjustment-products-fields').on(
    'cocoon:after-insert',
    function (e, addedProduct) {
      const lotSelect = addedProduct.find('.adjustment-product-lot-select');
      const locationSelect = addedProduct.find(
        '.adjustment-product-location-select'
      );

      lotSelect.select2({
        placeholder: 'Buscar un producto (código de lote o nombre)',
        minimumInputLength: 3,
        width: '100%',
      });
      locationSelect.select2({
        width: '100%',
      });

      axios
        .get('/product_lots_by_warehouse', {
          params: {
            plant_id: $('.adjustment_plant_select').val(),
            warehouse_ids: $('.adjustment_warehouses_select').val(),
          },
        })
        .then(response => {
          lotSelect.find('option').not(':first').remove();
          $.each(response.data, function (_, lot) {
            lotSelect.append(
              $('<option>', {
                text: lot.code_and_product,
                value: lot.id,
              })
            );
          });
          lotSelect.trigger('change');
        });

      lotSelect.change(function () {
        axios
          .get('/locations_by_product_lot', {
            params: {
              product_lot_id: lotSelect.val(),
            },
          })
          .then(response => {
            locationSelect.empty();
            $.each(response.data, function (_, location) {
              locationSelect.append(
                $('<option>', {
                  text: location.warehouse_path,
                  value: location.id,
                })
              );
            });
            locationSelect.trigger('change');
          });
      });
    }
  );
});
